var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 35,
    viewBox: "0 0 51 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.0718 26.4746L0 7.17969V15.7053L37.0718 35.0002V26.4746Z",
    fill: "#00E1C8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2397 26.4746L50.3115 7.17969V15.7053L13.2397 35.0002V26.4746Z",
    fill: "#00E1C8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7197 0V6.4335L25.1558 13.9103V7.47677L39.7197 0Z",
    fill: "url(#paint0_linear_10093:9798)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10093:9798",
    x1: 25.1558,
    y1: 8.97437,
    x2: 57.8143,
    y2: 8.97437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#118A6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5900B9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.cbc2b9e8bb79b17dbab9f0297722b97d.svg";
export { ForwardRef as ReactComponent };